import { render, staticRenderFns } from "./EmployerJobs.vue?vue&type=template&id=5fdf25a8&scoped=true"
import script from "./EmployerJobs.vue?vue&type=script&lang=js"
export * from "./EmployerJobs.vue?vue&type=script&lang=js"
import style0 from "./EmployerJobs.vue?vue&type=style&index=0&id=5fdf25a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf25a8",
  null
  
)

export default component.exports